import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, funciones} from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Table, TableSummaryRow} from '@devexpress/dx-react-grid-material-ui';
import DialogContent          from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Select from '../../components/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CheckIcon from '@material-ui/icons/Check';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const styles = theme => ({

paper: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '700px' : undefined, 
  maxWidth: !movil ? '700px' : undefined,
  minHeight: !movil ? '420px' : undefined, 
  maxHeight: !movil ? '420px' : undefined
}, 
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
container: {
 display: 'flex',
 justifyContent: !movil ? 'center' : undefined, 
 alignItems: !movil ? "center" : "start",
 flexDirection: !movil ? "row" : "column",
 paddingTop: "2px",
 paddingBottom: "5px", 
 paddingLeft: !movil ? theme.spacing(4) : theme.spacing(1),
 paddingRight: !movil ? theme.spacing(4) : theme.spacing(1), 
},
formControlSelect: {
 width: movil ? '100%' : '430px', 
 marginLeft: !movil ? theme.spacing(1) : undefined, 
 textAlign: 'left',
}
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [  
  { name: 'ID_FACTURA', title: 'N° Factura'},
  { name: 'FECHA_PROCESO', title: 'Fecha proceso'},
  { name: 'DESCRIPCION', title: 'Descripción'},
  { name: 'MONTO', title: 'Monto'},
  { name: 'DETALLE_CUOTAS', title: 'Detalle de cuotas'},
];
const columnExtensions = [ 
  { columnName: 'ID_FACTURA', width: widthTable * 0.11 },       
  { columnName: 'FECHA_PROCESO', width: widthTable * 0.12, align: "center"}, 
  { columnName: 'DESCRIPCION', width: widthTable * 0.30 },
  { columnName: 'MONTO', width: widthTable * 0.11, align: "center" },
  { columnName: 'DETALLE_CUOTAS', width: widthTable * 0.15, align: "center" },  
];
const totalSummaryItems = [
  { columnName: "MONTO", type: "sum" },
];

const columnsDetalle = [  
  { name: 'DESCRIPCION', title: 'Descripción'},
  { name: 'MONTO', title: 'Monto'},
  { name: 'MORA', title: 'Mora'},
  { name: 'BECA', title: 'Beca/Desc.'},
  { name: 'CREDITO', title: 'Crédito'},
  { name: 'PAGAR', title: 'Pagar'},
  { name: 'FINAN', title: 'Finan.'},
];
const columnExtensionsDetalle = [
  { columnName: 'DESCRIPCION', width: widthTable * 0.9 * (!movil ? 0.30 : 0.28) },
  { columnName: 'MONTO', width: widthTable * 0.9 * (!movil ? 0.10 : 0.09), align: "center" },  
  { columnName: 'MORA', width: widthTable * 0.9 * (!movil ? 0.10 : 0.09), align: "center" }, 
  { columnName: 'BECA', width: widthTable * 0.9 * (!movil ? 0.10 : 0.09), align: "center" }, 
  { columnName: 'CREDITO', width: widthTable * 0.9 * (!movil ? 0.10 : 0.09), align: "center" },
  { columnName: 'PAGAR', width: widthTable * 0.9 * (!movil ? 0.10 : 0.09), align: "center" },    
  { columnName: 'FINAN', width: widthTable * 0.9 * (!movil ? 0.10 : 0.09), align: "center" },
];

const columnsCuotas=[
  { name: 'DESCRIPCIÓN', title: 'Descripción' },
  { name: 'FECHA DE PAGO', title: 'Fecha de pago' },
  { name: 'MONTO', title: 'Monto' },
];
const columnExtensionsCuotas = [
  { columnName: 'DESCRIPCIÓN', width: 400 },
  { columnName: 'FECHA DE PAGO', width: 110, align: 'center' },
  { columnName: 'MONTO', width: 110, align: 'right' },
];

const RowId = row => row.ID_FACTURA;
const VirtualTable_cellComponent = (detalleCuotas) => (props) => {  
    
  if (props.column.name === 'FECHA_PROCESO'){
   return (<Table.Cell {...props}>
             {funciones.getTime(props.row.FECHA_PROCESO, 0)}
            </Table.Cell>
      );
  }

  if (props.column.name === "DETALLE_CUOTAS" && props.row.ID_TIPO_TRANSACCION === 5){
    return (<Table.Cell style={{ padding: 0 }} {...props}>
              <Button variant="contained" 
                      color="primary"
                      style={{ textTransform: "none" }}
                      onClick={detalleCuotas}
                      size="small"
                      >
                Ver
              </Button>
            </Table.Cell>);
  }  

  if (props.column.name === "MONTO" || props.column.name === "MORA" || props.column.name === "BECA" || props.column.name === "CREDITO" || props.column.name === "PAGAR" || props.column.name === "FINAN"){
   
  const simbolo = funciones.isEmpty(props.row.SIMBOLO) ? "" : props.row.SIMBOLO + " "; 

   return (<Table.Cell {...props}>
           {simbolo + funciones.formatCurrency(props.row[props.column.name])}
           </Table.Cell>);
  }

  return (<Table.Cell {...props}/>);
    
}

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();
tablaDialogRef = React.createRef();
dialogActionRef = React.createRef();

  constructor (props) { 
    super(props); 
    this.cargar=props.cargar
    this.state = {
      isLoggin : undefined,
      heightTableMain: 0,
      loadingMain: false,
      rows: [],
      itemsModPago: null,
      selectedModPago: '',
      loadingModPago: true,
      expandedRowIds: [],
      loadingDetail: false,
      openModal: false,
      heightTableDialog: 0,
      loadingCuotas: false,
      rowsCuotas: [],
   };
  this.RowDetail = ({ row }) => {
    
    const desplegados = this.facturaDetalle.length;
    const id_factura = this.facturaDetalle[desplegados-1];
    const styleDiv = { minWidth: 40, marginLeft: 5, marginTop: 5, position: "absolute", left: 0 }
  
    return(<div style={{ marginTop: 5, marginBottom: 5, width: !movil ? widthTable * 0.9 : "100%", position: 'relative', zIndex: 0, overflow: "hidden" }}>
            {this.state.loadingDetail && id_factura === row.ID_FACTURA ? <div style={styleDiv}><CircularProgress size={25} /></div> : <div style={styleDiv}/>}
             <div style={{ marginLeft: 50 }}>
             <CustomTable 
              Columns={columnsDetalle} 
              Rows={row.DETALLE_FACTURA === null ? [] : row.DETALLE_FACTURA}
              TableColumnExtensions={columnExtensionsDetalle}
              columnWidths={columnExtensionsDetalle}
              height={row.ID_TIPO_TRANSACCION === 5 ? 250 : 150}
              VirtualTable_cellComponent={VirtualTable_cellComponent(null)}
             />
             </div>
           </div>);
  }
  this.ItemComponent = ({children, ...props})=>{
    const monedas = this.monedas(); 

    if (monedas.length === 0)
      children = funciones.formatCurrency(parseFloat(children));
    else if (monedas.length === 1)
      children = monedas[0] + " " + funciones.formatCurrency(parseFloat(children));
    else
      children = this.calcular_totales(monedas);
      
    return (<TableSummaryRow.Item style={{ fontSize: 12 }} children={children} {...props} />);
  }
  this.facturaDetalle = [];
}

obtener_mod_pagos = ()=>{

new Request
 .get(`${globales.ip}/detallePago/modalidades_pago/${tokenInfo.user}/${tokenInfo.user}/${tokenInfo.plataforma}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
            
   if (err) { 
    
    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {    
     window.location.reload();
     return;                  
    }
    
    this.setState({ loadingModPago: false }, ()=>{ 
      funciones.showToast('e', 'No hay conexión'); 
    }); 
                    
    return;

   }
          
   let modalidades = JSON.parse(res.text);
   modalidades = modalidades.filter(x => x.VISIBLE_WEB || x.ID_MODALIDAD_CLIENTE);
   if (modalidades.find(x => x.ID_MODALIDAD_CLIENTE && !x.VISIBLE_WEB))
   modalidades = modalidades.filter(x => x.ID_MODALIDAD_CLIENTE && !x.VISIBLE_WEB);

   let selectedModPago = '';
   const itemsModPago = modalidades.map((item, i) =>{
     if (item.ID_MODALIDAD_CLIENTE) selectedModPago = item.MOD_PAGO_ID;
    return <MenuItem value={item.MOD_PAGO_ID} key={i}>{item.MOD_PAGO_DESCRIPCION}</MenuItem> 
   });

   this.setState({ itemsModPago, 
                   loadingModPago: false }, ()=>{
       this.handleChangeModPago({ target: { value: selectedModPago }});
    });                
       
});

}

obtener_facturas = (id_mod_pago_nueva, id_mod_pago)=>{

if (id_mod_pago === "") id_mod_pago = id_mod_pago_nueva;

new Request
 .post(`${globales.ip}/detallePago/modalidad`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .set('Content-Type', 'application/json')
 .send({ cuenta_alumno: tokenInfo.user, 
         id_mod_pago_nueva })
 .retry(0)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
   if (err) { 
  
    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {
              
     window.location.reload();
     return;
                
    }
        
    this.setState({ rows: [], expandedRowIds: [], selectedModPago: id_mod_pago, loadingMain: false }, ()=> { 
      funciones.showToast('e', 'No hay conexión'); 
    });
              
    return;
   }
        
  const rows = JSON.parse(res.text);
  this.setState({ loadingMain: false }, ()=>{
    if (rows.length > 0 && rows[0].RESP === undefined)
      this.setState({ expandedRowIds: [], rows });
    else if (rows.length > 0)
     this.setState({ selectedModPago: id_mod_pago }, ()=>{
      funciones.showToast('w', rows[0].RESP);
     });
    else
     this.setState({ expandedRowIds: [], rows });     
  });     

});

}

obtener_detalle= (id_factura)=>{

new Request
 .get(`${globales.ip}/detallePago/detalle/${id_factura}/${tokenInfo.user}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
          
   if (err) { 
  
    if (err.toString().substr(0,16) === 'Error: Forbidden')
    {
              
      window.location.reload();
      return;
                
    }
    
    this.facturaDetalle = this.facturaDetalle.filter(x => x !== id_factura);
    const expandedRowIds = this.state.expandedRowIds.slice().filter(x => x !== id_factura);
    this.setState({ expandedRowIds, loadingDetail: false }, ()=>{ 
      funciones.showToast('e', 'No hay conexión'); 
    }); 
                  
    return;
   }
        
  const rowsDetail = JSON.parse(res.text); 
  const rows = this.state.rows.slice().map((item)=>{
    if (item.ID_FACTURA === id_factura)
      item.DETALLE_FACTURA=rowsDetail; 

    return item;
  });
   
  this.setState({ rows, loadingDetail: false });    
                
 });

}

obtener_detalle_cuotas= ()=>{

  new Request
  .get(`${globales.ip}/detallePago/cuotas/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
              
        window.location.reload();
        return;
                
       }
  
       this.setState({ loadingCuotas: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión'); 
       }); 
                  
       return;
     }
        
     const rowsCuotas = JSON.parse(res.text).filter(x => !x.DESCRIPCIÓN.toLowerCase().includes("matr"));  
     this.setState({ rowsCuotas, loadingCuotas: false });      
                
 });

}

handleChangeModPago = (event)=>{ 
 const id_modalidad_pago = this.state.selectedModPago;  
 this.setState({ selectedModPago: event.target.value,
                 loadingMain: true }, ()=>{
    this.facturaDetalle = [];
    this.obtener_facturas(event.target.value, id_modalidad_pago);
 });
}

onExpandedRowDetailIdsChange=(expandedRowIds)=>{ 
 const id_factura = funciones.getIdRowChecking(expandedRowIds, this.state.expandedRowIds);

 if (expandedRowIds.length > this.state.expandedRowIds.length && !this.facturaDetalle.find(x => x === id_factura)){
   this.facturaDetalle.push(id_factura);
   this.setState({ loadingDetail: true, expandedRowIds }, ()=>{
     this.obtener_detalle(id_factura);
   });
 }
 else
  this.setState({ expandedRowIds });
}

detalle_cuotas = ()=>{
this.setState({ rowsCuotas: [], openModal: true });
}

handleClose = ()=>{
 this.setState({ openModal: false });
}

onEntering = ()=>{

this.setState({ loadingCuotas: true, 
                heightTableDialog: funciones.getHeightTableDialog(movil, this.tablaDialogRef, this.dialogActionRef, 3) }, ()=>{
  this.obtener_detalle_cuotas();
});

}

monedas = ()=>{

let monedas = [];

this.state.rows.map((item)=>{  
  if (!monedas.find(x => x === item.SIMBOLO))
    monedas.push(item.SIMBOLO);
  
  return item;
});

return monedas;

}

calcular_totales = (monedas)=>{

let rowsMoneda = [];
let monto = 0;
let resultado = "";

monedas.map((moneda, index)=>{
  
  monto = 0;
  rowsMoneda = this.state.rows.filter(x => x.SIMBOLO === moneda);
  rowsMoneda.map((item) => {
    monto += item.MONTO;
    return item;
  }); 
  
  resultado += moneda + " " + funciones.formatCurrency(monto) + (monedas.length === index + 1 ? "" : " | ");

  return moneda;
});

return resultado;

}

pagar = ()=>{ 
 this.cargar({reporte: false, i:true, e:true, l:true, pagina: 'Pago_Linea', nombre: 'Pago en línea', descripcion:'Pago en línea', icono: 'PaymentIcon', manual: false})();
}

componentDidMount() {
 
 tokenInfo = Auth.getProfile(); //Token decodificado

 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{  
  
  if (tokenInfo.plataforma === 2) //Usuario estudiante
  {
    this.obtener_mod_pagos();    
  }
    
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }); 

 }); 
             
}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 2) 
             {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>
                   <Select Label='Modalidad de pago'
                       Datos={this.state.itemsModPago} 
                       Selected={this.state.selectedModPago}
                       onChange={this.handleChangeModPago}
                       Style={classes.formControlSelect}                                  
                       Outlined />
                  <Divider orientation="vertical" flexItem style={{ margin: !movil ? "12px 20px" : "5px 0px" }}/>
                   <Button variant="contained" 
                      color="primary"
                      style={{ textTransform: "none" }}
                      startIcon={<CheckIcon fontSize="small" />}
                      disabled={this.state.rows.length === 0} 
                      onClick={this.pagar}
                     >
                    Realizar pago
                   </Button>
                 </div>
                 <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
                 <CustomTable 
                  Columns={columns} 
                  Rows={this.state.rows}                     
                  TableColumnExtensions={columnExtensions} 
                  columnWidths={columnExtensions}
                  getRowId={RowId}
                  VirtualTable_cellComponent={VirtualTable_cellComponent(this.detalle_cuotas)}
                  height={this.state.heightTableMain} 
                  loading={this.state.loadingMain}
                  ExpandedRowDetailIds={this.state.expandedRowIds}
                  onExpandedRowDetailIdsChange={this.onExpandedRowDetailIdsChange}
                  RowDetail={this.RowDetail}
                  totalItems={totalSummaryItems}
                  summaryRowMessages={{ sum: 'Total' }}
                  totalItemComponent={this.ItemComponent}       
                />                  
                </div>

                <Dialog open= {this.state.openModal}                            
                        TransitionProps={{ onEntering: this.onEntering }} 
                        classes={{ paper: classes.paper }}
                        fullScreen={movil}>
                 <DialogTitle><Typography component='span' variant='subtitle2'>Detalle de cuotas</Typography>
                  <IconButton className={classes.closeButton} onClick={this.handleClose} size="small">
                   <CloseIcon fontSize="small" />
                  </IconButton>
                 </DialogTitle>
                 <DialogContent style={{ paddingBottom: '0px'}}>
                 <div ref={this.tablaDialogRef} className="disableTouchOptions">
                  <CustomTable 
                    Columns={columnsCuotas} 
                    Rows={this.state.rowsCuotas}                
                    loading={this.state.loadingCuotas}
                    height = {this.state.heightTableDialog}                
                    VirtualTable_cellComponent={VirtualTable_cellComponent(null)}
                    TableColumnExtensions={columnExtensionsCuotas}
                  /> 
                  </div>
                 </ DialogContent>
                 <DialogActions ref={this.dialogActionRef} />
                </Dialog>

                <Backdrop open={this.state.loadingModPago || this.state.loadingMain || this.state.loadingDetail || this.state.loadingCuotas}
                          className={classes.backdrop} 
                          invisible 
                          transitionDuration={0}/>

                </React.Fragment>
              );

             }             
             
            })()

          }

          
        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)